import styled from 'styled-components'

import { layoutHeightCss } from '@root/shared/ui-kit/utils/page-layout'

import { BackOfficeBoard } from './back-office-board'

export const BackOfficePage: React.FC = () => (
  <Root>
    <BackOfficeBoard />
  </Root>
)

const Root = styled.div`
  ${layoutHeightCss}
  padding: 10px;
`
